import styled, { css } from "styled-components";
import { dashboardTheme } from "../../pages/OwnerDashboard/theme/dashboardTheme";

interface DarkVariantProps {
  $isDark?: boolean;
}

export const Container = styled.div<DarkVariantProps>`
  ${({ $isDark }) =>
    $isDark &&
    css`
      background: ${dashboardTheme.colors.footerBackground};
    `}
`;

export const Footer = styled.footer<DarkVariantProps>`
  max-width: 100%;
  padding: 48px 80px 24px;
  background: ${({ $isDark }) => ($isDark ? dashboardTheme.colors.footerBackground : "#F9F9F9")};
  border-top: ${({ $isDark }) =>
    $isDark ? `1px solid ${dashboardTheme.colors.footerBorder}` : "none"};
  position: relative;
  z-index: 1000;

  @media (max-width: 767px) {
    padding: 2rem 1.25rem 1.5rem;
  }

  @media (min-width: 1441px) {
    max-width: 100%;
    padding: 48px 100px 24px;
  }
`;

export const CopyrightText = styled.p<DarkVariantProps>`
  font-size: 9px;
  text-align: center;
  margin-top: 32px;
  color: ${({ $isDark }) =>
    $isDark ? dashboardTheme.colors.textMuted : "inherit"};

  @media (max-width: 767px) {
    font-size: 9px;
    line-height: 1.5;
    padding: 0 0.5rem;
  }

  @media (min-width: 1441px) {
    font-size: 12px;
  }
`;

export const FooterContent = styled.div<DarkVariantProps>`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
`;

export const ContactContainer = styled.div<DarkVariantProps>`
  display: flex;
  flex-direction: column;
  margin-right: 24px;

  > img {
    width: 130px;
    height: 35px;
    ${({ $isDark }) =>
      $isDark &&
      css`
        filter: brightness(0) invert(1);
        opacity: 0.9;
      `}
  }

  p {
    font-size: 13px;
    font-weight: 600;
    color: ${({ $isDark }) =>
      $isDark ? dashboardTheme.colors.textSecondary : "inherit"};
  }

  @media (max-width: 767px) {
    align-items: center;
    justify-content: center;
    margin-right: 0;

    > img {
      width: 138px;
      height: 39px;
    }

    > p {
      font-size: 14px;
    }
  }

  @media (min-width: 1441px) {
    > img {
      width: 150px;
      height: 43px;
    }

    p {
      font-size: 15px;
    }
  }
`;

export const SocialMedias = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;

  a {
    > img {
      width: 23px;
      height: 23px;
    }

    & + a {
      margin-left: 12px;
    }
  }

  @media (min-width: 1441px) {
    a {
      > img {
        width: 26px;
        height: 26px;
      }
    }
  }
`;

export const SimiliarContents = styled.div<DarkVariantProps>`
  display: flex;
  flex-direction: column;
  margin: 0 7.5%;

  b {
    font-size: 14px;
    margin-bottom: 24px;
    color: ${({ $isDark }) =>
      $isDark ? dashboardTheme.colors.textPrimary : "inherit"};
  }

  a {
    text-decoration: none;
    font-size: 12px;
    color: ${({ $isDark }) =>
      $isDark ? dashboardTheme.colors.textSecondary : "#666666"};
    margin-bottom: 12px;
    transition: color 0.2s ease;

    &:hover {
      color: ${({ $isDark }) =>
        $isDark ? dashboardTheme.colors.textPrimary : "#333333"};
    }
  }

  @media (max-width: 767px) {
    margin-top: 2rem;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  @media (min-width: 1441px) {
    > b {
      font-size: 16px;
    }

    > a {
      font-size: 14px;
    }
  }
`;
